import { render } from "./leaderboard-area-icon.vue?vue&type=template&id=451a8a02&ts=true"
import script from "./leaderboard-area-icon.vue?vue&type=script&lang=ts"
export * from "./leaderboard-area-icon.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__